const translations = {
  es: {
    title: "PorteroYa - Encuentra el Portero Perfecto para tu Partido",
    description: "Conéctate con porteros cualificados en tu área. Reserva con confianza y juega con los mejores. PorteroYa es la principal plataforma de España para encontrar y reservar porteros cualificados para tus partidos de fútbol."
  },
  ca: {
    title: "PorteroYa - Troba el Porter Perfecte pel teu Partit",
    description: "Connecta't amb porters qualificats a la teva zona. Reserva amb confiança i juga amb els millors. PorteroYa és la principal plataforma d'Espanya per trobar i reservar porters qualificats pels teus partits de futbol."
  },
  en: {
    title: "PorteroYa - Find the Perfect Goalkeeper for Your Match",
    description: "Connect with qualified goalkeepers in your area. Book with confidence and play with the best. PorteroYa is Spain's premier platform for finding and booking skilled goalkeepers for your football matches."
  }
};

export const updateMetaTags = (lang: string = 'en') => {
  const content = translations[lang as keyof typeof translations] || translations.en;
  
  // Update HTML lang attribute
  document.documentElement.lang = lang;

  // Update primary meta tags
  document.title = content.title;
  updateMetaTag('title', content.title);
  updateMetaTag('description', content.description);

  // Update Open Graph meta tags
  updateMetaTag('og:title', content.title);
  updateMetaTag('og:description', content.description);
  updateMetaTag('og:url', `https://porteroya.com/${lang}/coming-soon`);

  // Update Twitter meta tags
  updateMetaTag('twitter:title', content.title);
  updateMetaTag('twitter:description', content.description);
  updateMetaTag('twitter:url', `https://porteroya.com/${lang}/coming-soon`);
};

const updateMetaTag = (name: string, content: string) => {
  // Try to find the meta tag by name or property
  let meta = document.querySelector(`meta[name="${name}"]`) || 
             document.querySelector(`meta[property="${name}"]`);
             
  if (!meta) {
    // If the meta tag doesn't exist, create it
    meta = document.createElement('meta');
    if (name.startsWith('og:')) {
      meta.setAttribute('property', name);
    } else {
      meta.setAttribute('name', name);
    }
    document.head.appendChild(meta);
  }
  
  // Update the content
  meta.setAttribute('content', content);
};